import z from "zod";

import type { AttributeType, EntityType } from "@/api/admin/properties";
import type { MappedProperty } from "@/modules/SystemTags/components/mapProperty";
import { ARABIC_TEXT_WITH_NUMBERS_REGEX } from "@/utils/constants/arabicRegex";

export interface TagsBlockType {
  name: AttributeType;
  titleBlock: string;
  list: MappedProperty[];
  subtitle?: string;
  scope: EntityType;
}

export const TagSchema = z.object({
  id: z.string().optional(),
  nameEn: z
    .string()
    .min(1, "Tag name is required.")
    .max(50, "Tag name must not exceed 50 characters.")
    .regex(
      /^[\w\s&’'-]+$/,
      "Only letters, numbers, spaces, and & ’ ' - are allowed."
    )
    .trim(),
  nameAr: z
    .string()
    .min(1, "Tag name is required.")
    .max(50, "Tag name must not exceed 50 characters.")
    .regex(ARABIC_TEXT_WITH_NUMBERS_REGEX, {
      message: "Only Arabic characters and numbers are allowed.",
    })
    .trim(),
  mediaItem: z
    .object({
      type: z.string(),
      url: z.string(),
    })
    .nullable()
    .optional(),
  imageUrl: z.string().nullable().optional(),
});

export const FormSchema = z.object({
  rows: z.array(TagSchema).min(1),
});

export type NewTagFormType = z.infer<typeof FormSchema>;

export type TagFormType = z.infer<typeof TagSchema>;
